import React from "react";
import { fromPublic } from "../../../../utils";
import { QuotaContainer, InfoText, OutlineWarningIcon } from "../styles";

interface QuotaStateProps {
  text: string;
  icon: string;
}

const QuotaState: React.FC<QuotaStateProps> = ({ text, icon }) => (
  <QuotaContainer>
    <OutlineWarningIcon src={fromPublic(icon)} alt="Warning" />
    <InfoText>{text}</InfoText>
  </QuotaContainer>
);

export default QuotaState;
